// extracted by mini-css-extract-plugin
module.exports = {"horizontalCarouselRightArrow":"HorizontalCarouselRightArrow_horizontalCarouselRightArrow__45KoU","float":"HorizontalCarouselRightArrow_float__kkli2"};